<div class="modal-backdrop" *ngIf="isVisible" (click)="onBackdropClick($event)">
  <div class="modal-content">
    <div class="modal-header">
      <h2>Appointment Details</h2>
      <div class="header-actions">
        <button class="close-btn" (click)="onClose()">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="modal-body" *ngIf="appointment">
      <div class="appointment-id-section">
        <div>
          <p class="label">APPOINTMENT ID</p>
          <p class="value">
            {{ appointment.appointment_code }}
            <span
              class="status-badge"
              [ngClass]="getStatusBadgeClass(appointment.appointment_status)"
            >
              {{ getStatusLabel(appointment.appointment_status) }}
            </span>
          </p>
        </div>
        <div
          class="header-actions-bottom"
          *ngIf="
            appointment?.appointment_status !== 'completed' &&
            appointment?.appointment_status !== 'cancelled'
          "
        >
          <svg
            #menuButton
            (click)="toggleDropdown($event)"
            class="menu-btn-svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 4C0 1.79086 1.79086 0 4 0H26C28.2091 0 30 1.79086 30 4V26C30 28.2091 28.2091 30 26 30H4C1.79086 30 0 28.2091 0 26V4Z"
              fill="#E6E8F4"
            />
            <path
              d="M14.333 15.0013C14.333 15.1781 14.4032 15.3477 14.5283 15.4727C14.6533 15.5977 14.8229 15.668 14.9997 15.668C15.1765 15.668 15.3461 15.5977 15.4711 15.4727C15.5961 15.3477 15.6663 15.1781 15.6663 15.0013C15.6663 14.8245 15.5961 14.6549 15.4711 14.5299C15.3461 14.4049 15.1765 14.3346 14.9997 14.3346C14.8229 14.3346 14.6533 14.4049 14.5283 14.5299C14.4032 14.6549 14.333 14.8245 14.333 15.0013Z"
              stroke="#15172E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.333 19.668C14.333 19.8448 14.4032 20.0143 14.5283 20.1394C14.6533 20.2644 14.8229 20.3346 14.9997 20.3346C15.1765 20.3346 15.3461 20.2644 15.4711 20.1394C15.5961 20.0143 15.6663 19.8448 15.6663 19.668C15.6663 19.4912 15.5961 19.3216 15.4711 19.1966C15.3461 19.0715 15.1765 19.0013 14.9997 19.0013C14.8229 19.0013 14.6533 19.0715 14.5283 19.1966C14.4032 19.3216 14.333 19.4912 14.333 19.668Z"
              stroke="#15172E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.333 10.3346C14.333 10.5114 14.4032 10.681 14.5283 10.806C14.6533 10.9311 14.8229 11.0013 14.9997 11.0013C15.1765 11.0013 15.3461 10.9311 15.4711 10.806C15.5961 10.681 15.6663 10.5114 15.6663 10.3346C15.6663 10.1578 15.5961 9.98826 15.4711 9.86323C15.3461 9.73821 15.1765 9.66797 14.9997 9.66797C14.8229 9.66797 14.6533 9.73821 14.5283 9.86323C14.4032 9.98826 14.333 10.1578 14.333 10.3346Z"
              stroke="#15172E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>

      <div class="tabs">
        <div class="tab" [class.active]="activeTab === 'booking'" (click)="selectTab('booking')">
          <svg
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.25002 2.41667H2.08335C1.77393 2.41667 1.47719 2.53958 1.2584 2.75838C1.0396 2.97717 0.916687 3.27391 0.916687 3.58333V10.5833C0.916687 10.8928 1.0396 11.1895 1.2584 11.4083C1.47719 11.6271 1.77393 11.75 2.08335 11.75H7.91669C8.22611 11.75 8.52285 11.6271 8.74164 11.4083C8.96044 11.1895 9.08335 10.8928 9.08335 10.5833V3.58333C9.08335 3.27391 8.96044 2.97717 8.74164 2.75838C8.52285 2.53958 8.22611 2.41667 7.91669 2.41667H6.75002M3.25002 2.41667C3.25002 2.10725 3.37294 1.8105 3.59173 1.59171C3.81052 1.37292 4.10727 1.25 4.41669 1.25H5.58335C5.89277 1.25 6.18952 1.37292 6.40831 1.59171C6.6271 1.8105 6.75002 2.10725 6.75002 2.41667M3.25002 2.41667C3.25002 2.72609 3.37294 3.02283 3.59173 3.24162C3.81052 3.46042 4.10727 3.58333 4.41669 3.58333H5.58335C5.89277 3.58333 6.18952 3.46042 6.40831 3.24162C6.6271 3.02283 6.75002 2.72609 6.75002 2.41667M3.25002 6.5H3.25585M5.58335 6.5H6.75002M3.25002 8.83333H3.25585M5.58335 8.83333H6.75002"
              stroke="#15172E"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          Booking Summary
        </div>
        <div class="tab" [class.active]="activeTab === 'customer'" (click)="selectTab('customer')">
          <svg
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.5 11.75V10.5833C1.5 9.96449 1.74583 9.371 2.18342 8.93342C2.621 8.49583 3.21449 8.25 3.83333 8.25H6.16667C6.7855 8.25 7.379 8.49583 7.81658 8.93342C8.25417 9.371 8.5 9.96449 8.5 10.5833V11.75M2.66667 3.58333C2.66667 4.20217 2.9125 4.79566 3.35008 5.23325C3.78767 5.67083 4.38116 5.91667 5 5.91667C5.61884 5.91667 6.21233 5.67083 6.64992 5.23325C7.0875 4.79566 7.33333 4.20217 7.33333 3.58333C7.33333 2.96449 7.0875 2.371 6.64992 1.93342C6.21233 1.49583 5.61884 1.25 5 1.25C4.38116 1.25 3.78767 1.49583 3.35008 1.93342C2.9125 2.371 2.66667 2.96449 2.66667 3.58333Z"
              stroke="#15172E"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          Customer Info
        </div>
        <div class="tab" [class.active]="activeTab === 'vehicle'" (click)="selectTab('vehicle')">
          <svg
            width="12"
            height="10"
            viewBox="0 0 12 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.91667 7.41667C1.91667 7.72609 2.03958 8.02283 2.25838 8.24162C2.47717 8.46042 2.77391 8.58333 3.08333 8.58333C3.39275 8.58333 3.6895 8.46042 3.90829 8.24162C4.12708 8.02283 4.25 7.72609 4.25 7.41667M1.91667 7.41667C1.91667 7.10725 2.03958 6.8105 2.25838 6.59171C2.47717 6.37292 2.77391 6.25 3.08333 6.25C3.39275 6.25 3.6895 6.37292 3.90829 6.59171C4.12708 6.8105 4.25 7.10725 4.25 7.41667M1.91667 7.41667H0.75V3.91667M4.25 7.41667H7.75M7.75 7.41667C7.75 7.72609 7.87292 8.02283 8.09171 8.24162C8.3105 8.46042 8.60725 8.58333 8.91667 8.58333C9.22609 8.58333 9.52283 8.46042 9.74162 8.24162C9.96042 8.02283 10.0833 7.72609 10.0833 7.41667M7.75 7.41667C7.75 7.10725 7.87292 6.8105 8.09171 6.59171C8.3105 6.37292 8.60725 6.25 8.91667 6.25C9.22609 6.25 9.52283 6.37292 9.74162 6.59171C9.96042 6.8105 10.0833 7.10725 10.0833 7.41667M10.0833 7.41667H11.25V5.08333C11.25 4.77391 11.1271 4.47717 10.9083 4.25838C10.6895 4.03958 10.3928 3.91667 10.0833 3.91667H9.5M0.75 3.91667L1.91667 1H7.16667L9.5 3.91667M0.75 3.91667H9.5M6 3.91667V1"
              stroke="#15172E"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          Vehicle Details
        </div>
      </div>

      <div class="tab-content" *ngIf="activeTab === 'booking'">
        <h3 class="card-title p2 font-medium">Package Details</h3>
        <div class="card">
          <div class="package-details">
            <div class="package-info">
              <p class="package-name">{{ appointment.package_name }}</p>
              <p class="appointment-id-subtle">{{ appointment.appointment_code }}</p>
            </div>
            <!-- Assuming price is not in the model, so hardcoding for now -->
            <p class="package-price">${{ appointment.price || appointment.single_list_price }}</p>
          </div>
          <hr />
          <div class="details-grid">
            <div class="detail-item">
              <p class="label">DATE OF PURCHASE</p>
              <p class="value">{{ appointment.created_at | date: 'MMM dd, yyyy' }}</p>
            </div>
            <div class="detail-item">
              <p class="label">SOURCE</p>
              <p class="value">{{ appointment.source }}</p>
            </div>
          </div>
        </div>
        <div class="card-header">
          <h3 class="m0 p1 font-medium">Appointment Info</h3>
          <button
            class="edit-btn"
            (click)="onEdit()"
            *ngIf="!isEditing && !isStaffUser && appointment?.appointment_status !== 'completed'"
          >
            <img src="assets/images/vehicle/edit-icon.svg" alt="Edit" />
            Edit
          </button>
        </div>
        <div class="card" *ngIf="!isEditing">
          <div class="details-grid">
            <div class="detail-item">
              <p class="label">LOCATION</p>
              <p class="value">{{ appointment.branch }}</p>
            </div>
            <div class="detail-item">
              <p class="label">STAFF</p>
              <p class="value">{{ appointment.employee_name }}</p>
            </div>
            <div class="detail-item">
              <p class="label">DATE & TIME OF APPOINTMENT</p>
              <p class="value">{{ formatAppointmentDisplayTime(appointment) }}</p>
            </div>
            <div class="detail-item">
              <p class="label">DURATION</p>
              <p class="value">{{ formatDuration(appointment.duration) }}</p>
            </div>
            <div class="detail-item" *ngIf="appointment.cancellation_date">
              <p class="label">DATE OF CANCELLATION</p>
              <p class="value">
                {{ appointment.cancellation_date | date: 'MMM dd, yyyy | h:mm a' }}
              </p>
            </div>
          </div>
        </div>
        <app-appointment-edit-form
          *ngIf="isEditing"
          [appointment]="appointment"
          (cancel)="onCancelAppointmentEdit()"
          (save)="onSaveAppointmentEdit($event)"
        ></app-appointment-edit-form>
      </div>

      <div class="tab-content" *ngIf="activeTab === 'customer'">
        <app-customer-information [appointment]="appointment"></app-customer-information>
      </div>

      <div class="tab-content" *ngIf="activeTab === 'vehicle'">
        <div class="card-header">
          <h3 class="m0 p1 font-medium">Vehicle Details</h3>
          <button
            class="edit-btn"
            (click)="onAddNewVehicle()"
            *ngIf="showEditingVehicle && vehicleData && vehicleData.length < 5 && !isStaffUser"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M10 4V16M4 10H16"
                stroke="#326FD1"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Add Vehicle
          </button>
        </div>
        <!-- Vehicle Details Card based on Figma Design -->

        <div class="vehicle-details-card" *ngIf="!showEditingVehicle">
          <div class="vehicle-details-header">
            <div class="vehicle-info">
              <h3 class="vehicle-title">
                {{ appointment.vehicle_year || appointment.year }}
                {{ appointment.vehicle_make || appointment.make }}
                {{ appointment.vehicle_model || appointment.model }}
              </h3>
            </div>
            <div class="vehicle-actions">
              <button
                class="action-btn edit-btn"
                (click)="onOpenVehicleManagement()"
                *ngIf="!isStaffUser && appointment?.appointment_status !== 'completed'"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5 3.33333L16.6667 7.5M2.5 18.3333H6.66667L17.5 7.5C17.7208 7.27917 17.9028 7.02361 18.0389 6.74306C18.175 6.4625 18.2633 6.16111 18.3007 5.85069C18.3381 5.54028 18.3241 5.22569 18.2593 4.92083C18.1944 4.61597 18.0796 4.32569 17.9208 4.0625C17.762 3.79931 17.5611 3.56736 17.3264 3.37639C17.0917 3.18542 16.8264 3.03819 16.5417 2.94028C16.2569 2.84236 15.9569 2.79514 15.6556 2.80069C15.3542 2.80625 15.0569 2.86458 14.7764 2.97292L2.5 15.25V18.3333Z"
                    stroke="#326FD1"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div class="vehicle-details-content">
            <div class="detail-row">
              <div class="detail-item">
                <span class="detail-label">LICENSE PLATE</span>
                <span class="detail-value">{{
                  appointment.vehicle_license_plate ||
                    appointment.licensePlate ||
                    appointment.license_plate ||
                    'N/A'
                }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">VIN</span>
                <span class="detail-value">{{
                  appointment.vehicle_vin || appointment.vin || 'N/A'
                }}</span>
              </div>
            </div>
            <!-- <div class="detail-row">
      <div class="detail-item">
        <span class="detail-label">FAMILY PLAN VEHICLE</span>
        <span class="detail-value">Yes</span>
      </div>
    </div> -->
          </div>

          <!-- Edit History Section - Only show if created_at and updated_at are different -->
          <div class="edit-history-card" *ngIf="shouldShowEditHistory">
            <h3 class="edit-history-title">Edit History</h3>
            <div class="edit-history-timeline">
              <div
                class="timeline-item"
                *ngFor="let item of editHistory; let i = index; trackBy: trackByIndex"
              >
                <div class="timeline-dot" [class]="item.type"></div>
                <div class="timeline-content">
                  <div class="timeline-text">{{ item.action }}</div>
                  <div class="timeline-date">{{ item.date | date: 'MMM d, y, h:mm a' }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- here -->
        </div>

        <div class="show-after-edit-cliked" *ngIf="showEditingVehicle">
          <!-- Show vehicle edit form when editing -->
          <!-- Show add vehicle card when adding new vehicle -->
          <app-add-vehicle-card
            *ngIf="isAddingNewVehicle"
            #addVehicleCardComponent
            [isVisible]="isAddingNewVehicle"
            [customerId]="appointment.customer_id || ''"
            [editMode]="false"
            (cardClosed)="onVehicleCardClosed()"
            (vehicleAdded)="onVehicleAdded($event)"
          >
          </app-add-vehicle-card>

          <div class="card h-100">
            <!-- Vehicle Limit Warning -->
            <div class="vehicle-limit-warning" *ngIf="vehicleData && vehicleData.length >= 5">
              <div class="warning-content">
                <div class="warning-icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="9.99935" cy="10.0003" r="8.33333" fill="#F57600" />
                    <path
                      d="M9.99203 12.5H9.99951"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10 10L10 6.66667"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="warning-text">
                  <div class="warning-title">Vehicle limit reached!</div>
                  <div class="warning-message">
                    You can only add up to 5 vehicles to a family plan. Remove an existing vehicle
                    to add another.
                  </div>
                </div>
              </div>
            </div>
            <!-- Vehicle Details Card based on Figma Design -->
            <div
              class="over-inner-scroll"
              [ngClass]="{ 'single-vehicle': vehicleData.length === 1 }"
            >
              <!-- Show vehicle selection list when vehicles are fetched and not editing -->
              <div
                *ngIf="vehicleData && vehicleData.length > 0"
                class="vehicle-selection-container"
              >
                <!--
                  The ControlValueAccessor lives on mat-radio-group, not on the individual
                  mat-radio-button, so [(ngModel)] belongs here (NG01203 otherwise).
                  The group finds its buttons with descendants: true, so nesting inside
                  the *ngFor cards is fine.
                -->
                <mat-radio-group
                  class="vehicle-list"
                  name="vehicle"
                  [(ngModel)]="selectedVehicleIndex"
                  (ngModelChange)="onVehicleSelectionChange($event)"
                >
                  <div
                    *ngFor="let vehicle of vehicleData; let i = index; trackBy: trackByIndex"
                    class="vehicle-card"
                    [class.selected]="selectedVehicleIndex === i"
                  >
                    <div *ngIf="editingVehicleData?.id !== vehicle.id">
                      <div class="vehicle-header">
                        <div class="vehicle-select">
                          <mat-radio-button [value]="i"></mat-radio-button>
                          <label [for]="'vehicle-' + i" class="vehicle-name"
                            >{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}</label
                          >
                        </div>
                        <div class="vehicle-actions">
                          <button
                            class="action-btn edit-btn"
                            (click)="editVehicle(vehicle, i)"
                            *ngIf="!isStaffUser"
                          >
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 15 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.2487 2.41627L12.582 5.7496M1.33203 13.6663H4.66536L13.4154 4.91627C13.6342 4.6974 13.8079 4.43756 13.9263 4.15159C14.0448 3.86563 14.1057 3.55913 14.1057 3.2496C14.1057 2.94007 14.0448 2.63357 13.9263 2.34761C13.8079 2.06164 13.6342 1.8018 13.4154 1.58293C13.1965 1.36406 12.9367 1.19045 12.6507 1.072C12.3647 0.953545 12.0582 0.892578 11.7487 0.892578C11.4392 0.892578 11.1327 0.953545 10.8467 1.072C10.5607 1.19045 10.3009 1.36406 10.082 1.58293L1.33203 10.3329V13.6663Z"
                                stroke="#326FD1"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div class="vehicle-details">
                        <div class="detail-row">
                          <div class="detail-item">
                            <span class="detail-label">LICENSE PLATE</span>
                            <span class="detail-value">{{
                              vehicle.license_plate || vehicle.licensePlate || 'N/A'
                            }}</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">VIN</span>
                            <span class="detail-value">{{ vehicle.vin || 'N/A' }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <app-vehicle-list
                      *ngIf="
                        isEditingVehicle &&
                        editingVehicleData &&
                        editingVehicleData?.id === vehicle.id
                      "
                      #vehicleEditComponent
                      [isEditMode]="true"
                      [editVehicleData]="editingVehicleData"
                      [customerId]="appointment?.customer_id || ''"
                      (cancelEdit)="onCancelEdit()"
                      (saveEdit)="onSaveEdit($event)"
                      [fromAppointment]="true"
                    >
                    </app-vehicle-list>
                  </div>
                </mat-radio-group>
              </div>

              <!-- Show vehicle input form when no vehicles are fetched and not editing -->
              <app-vehicle-list
                *ngIf="
                  (!vehicleData || vehicleData.length === 0) &&
                  !isEditingVehicle &&
                  !isAddingNewVehicle
                "
                #vehicleListComponent
                [initialData]="vehicleFormData"
                (formDataChange)="onVehicleFormDataChange($event)"
              >
              </app-vehicle-list>
            </div>
            <div class="btn-outline-cancel" *ngIf="showEditingVehicle">
              <button class="btn btn-tertiary btn-medium" (click)="onCloseVehicleManagement()">
                Cancel
              </button>
            </div>
            <div class="form-footer" *ngIf="hasVehicleSelectionChanged">
              <div></div>
              <!--bindings={
          "ng-reflect-ng-if": "true"
        }--><button
                class="btn btn-primary btn-medium"
                [class.btn-disabled]="selectedVehicleIndex === -1 || isSelectingVehicle"
                [disabled]="selectedVehicleIndex === -1 || isSelectingVehicle"
                (click)="onSelectVehicle()"
              >
                <!--bindings={
          "ng-reflect-ng-if": "false"
        }--><span class="ng-star-inserted">{{
                  isSelectingVehicle ? 'Updating...' : 'Select Vehicle'
                }}</span
                ><!--bindings={
          "ng-reflect-ng-if": "true"
        }-->
              </button>
            </div>

            <!-- here -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Dropdown Backdrop -->
  <div class="dropdown-backdrop" *ngIf="showDropdown" (click)="closeDropdown()"></div>

  <!-- Custom Dropdown Menu -->
  <div
    class="custom-dropdown-menu"
    *ngIf="showDropdown"
    [style.top.px]="dropdownPosition.top"
    [style.left.px]="dropdownPosition.left"
  >
    <div
      class="dropdown-item"
      *ngIf="
        appointment?.appointment_status !== 'completed' &&
        appointment?.appointment_status !== 'cancelled'
      "
      (click)="markCompleteFromDropdown()"
    >
      <span>Mark Complete</span>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.25 6L5.41667 7.16667L7.75 4.83333M0.75 6C0.75 6.68944 0.885795 7.37213 1.14963 8.00909C1.41347 8.64605 1.80018 9.2248 2.28769 9.71231C2.7752 10.1998 3.35395 10.5865 3.99091 10.8504C4.62787 11.1142 5.31056 11.25 6 11.25C6.68944 11.25 7.37213 11.1142 8.00909 10.8504C8.64605 10.5865 9.2248 10.1998 9.71231 9.71231C10.1998 9.2248 10.5865 8.64605 10.8504 8.00909C11.1142 7.37213 11.25 6.68944 11.25 6C11.25 5.31056 11.1142 4.62787 10.8504 3.99091C10.5865 3.35395 10.1998 2.7752 9.71231 2.28769C9.2248 1.80018 8.64605 1.41347 8.00909 1.14963C7.37213 0.885795 6.68944 0.75 6 0.75C5.31056 0.75 4.62787 0.885795 3.99091 1.14963C3.35395 1.41347 2.7752 1.80018 2.28769 2.28769C1.80018 2.7752 1.41347 3.35395 1.14963 3.99091C0.885795 4.62787 0.75 5.31056 0.75 6Z"
          stroke="#555963"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div
      class="dropdown-item"
      *ngIf="isAdminUser && appointment?.appointment_status !== 'completed'"
      (click)="rescheduleFromDropdown()"
    >
      <span>Reschedule</span>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6668 6.41666C11.5242 5.39012 11.048 4.43896 10.3115 3.7097C9.57512 2.98044 8.61935 2.51353 7.59147 2.3809C6.56359 2.24827 5.52061 2.45727 4.6232 2.97572C3.72578 3.49416 3.02372 4.29329 2.62516 5.24999M2.3335 2.91666V5.24999H4.66683M2.3335 7.58332C2.47616 8.60986 2.95237 9.56102 3.68879 10.2903C4.42521 11.0195 5.38097 11.4864 6.40886 11.6191C7.43674 11.7517 8.47972 11.5427 9.37713 11.0243C10.2745 10.5058 10.9766 9.70669 11.3752 8.74998M11.6668 11.0833V8.74998H9.3335"
          stroke="#555963"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div
      class="dropdown-item danger"
      *ngIf="isAdminUser && appointment?.appointment_status !== 'cancelled'"
      (click)="cancelFromDropdown()"
    >
      <span>Cancel</span>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.95833 4.95833L9.04167 9.04167M4.95833 9.04167L9.04167 4.95833M7 12.25C8.39239 12.25 9.72774 11.6969 10.7123 10.7123C11.6969 9.72774 12.25 8.39239 12.25 7C12.25 5.60761 11.6969 4.27226 10.7123 3.28769C9.72774 2.30312 8.39239 1.75 7 1.75C5.60761 1.75 4.27226 2.30312 3.28769 3.28769C2.30312 4.27226 1.75 5.60761 1.75 7C1.75 8.39239 2.30312 9.72774 3.28769 10.7123C4.27226 11.6969 5.60761 12.25 7 12.25Z"
          stroke="#DA1E28"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</div>
